const pluralizeTime = (number: number) => {
  return number === 1 ? '' : 's';
};

export const renderTime = (time: string) => {
  const now = new Date();
  const date = new Date(time);
  const diff = now.getTime() - date.getTime();

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(weeks / 4);
  const years = Math.floor(months / 12);

  if (seconds < 60) {
    return `${seconds} second${pluralizeTime(seconds)} ago`;
  }
  if (minutes < 60) {
    return `${minutes} minute${pluralizeTime(minutes)} ago`;
  }
  if (hours < 24) {
    return `${hours} hour${pluralizeTime(hours)} ago`;
  }
  if (days < 7) {
    return `${days} day${pluralizeTime(days)} ago`;
  }
  if (weeks < 4) {
    return `${weeks} week${pluralizeTime(weeks)} ago`;
  }
  if (months < 12) {
    return `${months} month${pluralizeTime(months)} ago`;
  }

  return `${years} year${pluralizeTime(years)} ago`;
};
